import React from "react";

import PageHero from "../../components/common/PageHero";
import PageSectionHeader from "../../components/common/PageSectionHeader";
import useScrollToTop from "../../hooks/useScollToTop";
import ScrollIndicator from "../Home/ScrollIndicator";

import AssociationCard from "./components/AssociationCard";
import AssociationsEmptyState from "./components/AssociationsEmptyState";
import AssociationsFilters from "./components/AssociationsFilters";
import AssociationsSkeleton from "./components/AssociationsSkeleton";

import { ASSOCIATIONS_PAGE } from "./data/associationsUiData";
import { useAssociationsPage } from "./hooks/useAssociationsPage";

export default function AssociationsPage() {
  useScrollToTop();

  const {
    loading,
    error,
    items,
    total,
    allTotal,
    categories,
    filters,
    expandedMapId,
    updateFilter,
    resetFilters,
    toggleCategory,
    toggleMap,
    refresh,
  } = useAssociationsPage();

  return (
    <>
      <PageHero
        title="Associations"
        imageUrl={ASSOCIATIONS_PAGE.heroImageUrl}
        crumbs={ASSOCIATIONS_PAGE.crumbs}
      />

      <ScrollIndicator />

      <main className="mx-auto max-w-[1240px] px-4 pb-16 pt-6 sm:px-6 md:pt-8">
        <PageSectionHeader
          eyebrow={ASSOCIATIONS_PAGE.eyebrow}
          title={ASSOCIATIONS_PAGE.title}
          description={ASSOCIATIONS_PAGE.description}
        >
          <div className="rounded-3xl border border-slate-200 bg-white/80 px-5 py-4 shadow-sm backdrop-blur dark:border-slate-800 dark:bg-slate-950/70">
            <p className="text-xs font-bold uppercase tracking-[0.18em] text-slate-500 dark:text-slate-400">
              Associations actives
            </p>
            <p className="mt-1 text-3xl font-bold text-slate-950 dark:text-white">
              {loading ? "…" : allTotal}
            </p>
            <p className="mt-1 text-sm text-slate-500 dark:text-slate-400">
              référencée{allTotal > 1 ? "s" : ""}
            </p>
          </div>
        </PageSectionHeader>

        <div className="mt-5">
          <AssociationsFilters
            loading={loading}
            filters={filters}
            categories={categories}
            total={total}
            allTotal={allTotal}
            onChange={updateFilter}
            onReset={resetFilters}
            onCategoryClick={toggleCategory}
            onRefresh={refresh}
          />
        </div>

        {error && (
          <div className="mt-5 rounded-3xl border border-red-200 bg-red-50 px-5 py-4 text-sm font-semibold text-red-700 dark:border-red-900/60 dark:bg-red-950/30 dark:text-red-300">
            Une erreur est survenue pendant le chargement des associations.
          </div>
        )}

        <section className="mt-6">
          {loading ? (
            <AssociationsSkeleton />
          ) : items.length > 0 ? (
            <div className="grid gap-5 lg:grid-cols-2">
              {items.map((association) => (
                <AssociationCard
                  key={association.id}
                  association={association}
                  isMapOpen={expandedMapId === association.id}
                  onToggleMap={() => toggleMap(association.id)}
                />
              ))}
            </div>
          ) : (
            <AssociationsEmptyState onReset={resetFilters} />
          )}
        </section>
      </main>
    </>
  );
}